import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Box, forwardRef } from '@chakra-ui/react';
import React from 'react';
var CarouselChild = forwardRef(function (props, forwardedRef) {
  var children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["children"]);

  return /*#__PURE__*/React.createElement(Box, Object.assign({
    ref: forwardedRef
  }, rest), children);
});
export default CarouselChild;